module.exports = __webpack_public_path__ + "img/ico_yjyc.77295292.png";